import { httpClient } from '@/lib/http-client'
import { type PagedRequest, buildPagedParams } from '@/shared/types'

export const organizationsApi = {
    list: (params?: PagedRequest) =>
        httpClient.get('/organizations', { params: Object.fromEntries(buildPagedParams(params)) }),
    create: (data: any) => httpClient.post('/organizations', data),
    get: (id: string) => httpClient.get(`/organizations/${id}`),
    update: (id: string, data: any) => httpClient.put(`/organizations/${id}`, data),
    delete: (id: string) => httpClient.delete(`/organizations/${id}`),
    members: (id: string) => httpClient.get(`/organizations/${id}/members`),

    updateUserRole: (orgId: string, userId: string, role: string) =>
        httpClient.put(`/organizations/${orgId}/users/${userId}/role`, { role }),
    assessments: (id: string) => httpClient.get(`/organizations/${id}/assessments`),
    addMember: (orgId: string, userId: string, role = 'member') =>
        httpClient.post(`/organizations/${orgId}/members`, { user_id: userId, role }),
    removeMember: (orgId: string, userId: string) =>
        httpClient.delete(`/organizations/${orgId}/members/${userId}`),
    adminUpdate: (id: string, data: any) => httpClient.put(`/organizations/admin/${id}`, data),
    adminDelete: (id: string) => httpClient.delete(`/organizations/admin/${id}`),
}
